module.exports = __webpack_public_path__ + "static/media/discoverTutorial.5727c280.svg";